import { Extension } from '@tiptap/core'

const BackgroundColor = Extension.create({
  name: 'backColor',

  addOptions() {
    return {
      types: ['tableCell', 'tableRow', 'table', 'tableHeader'],
    }
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (element) => element.style.backgroundColor,
            renderHTML: (attributes) => {
              if (!attributes.backgroundColor) {
                return {}
              }

              return {
                style: `background-color: ${attributes.backgroundColor}`,
              }
            },
          },
        },
      },
    ]
  },
})

export default BackgroundColor
